import { AppThunk } from '../../ThunkTypes';
import {
  updateCurrentStepInspection,
  setIsStartedInspection,
  updateCurrentStepEmission,
  setIsStartedEmission,
  setIsOnPackageSelection,
  updateIsOnThirdPartyPayment,
} from '../slice/steppersSlice';

export const setStepperInspection =
  (currentPage: number): AppThunk =>
  (dispatch): void => {
    dispatch(updateCurrentStepInspection(currentPage));
  };

export const setStartedInspection =
  (value: boolean): AppThunk =>
  (dispatch): void => {
    dispatch(setIsStartedInspection(value));
  };

export const setStepperEmission =
  (currentPage: number): AppThunk =>
  (dispatch): void => {
    dispatch(updateCurrentStepEmission(currentPage));
  };

export const setStartedEmission =
  (value: boolean): AppThunk =>
  (dispatch): void => {
    dispatch(setIsStartedEmission(value));
  };

export const setOnPackageSelection =
  (value: boolean): AppThunk =>
  (dispatch): void => {
    dispatch(setIsOnPackageSelection(value));
  };

export const setIsOnThirdPartyPayment =
  (value: boolean): AppThunk =>
  (dispatch): void => {
    dispatch(updateIsOnThirdPartyPayment(value));
  };
